import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import "@/index.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { LandingPage } from "@/components/pages/LandingPage";
import { DemoPage } from "@/components/pages/DemoPage";
import { MasterPartnerPage } from "@/components/pages/MasterPartnerPage";
import { BuyerLandingPage } from "@/components/pages/BuyerLandingPage";
import { HazMatchPage } from "@/components/pages/HazMatchPage";
import { AgentLandingPage } from "@/components/pages/AgentLandingPage";
import { SellerLandingPage } from "@/components/pages/SellerLandingPage";
import { AuthPage } from "@/components/pages/AuthPage";
import { OnboardingPage } from "@/components/pages/OnboardingPage";
import { SwipePage } from "@/components/pages/SwipePage";
import { PaymentPage } from "@/components/pages/PaymentPage";
import { MatchesPage } from "@/components/pages/MatchesPage";
import { AgentDashboard } from "@/components/pages/AgentDashboard";
import { AdminDashboard } from "@/components/pages/AdminDashboard";
import { OwnerDashboard } from "@/components/pages/OwnerDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/comprador" element={<BuyerLandingPage />} />
            <Route path="/haz-match" element={<HazMatchPage />} />
            <Route path="/conviertete-en-agente" element={<AgentLandingPage />} />
            <Route path="/vende-tu-propiedad" element={<SellerLandingPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/partner/:slug" element={<MasterPartnerPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute allowedRoles={["shopper"]}>
                  <OnboardingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/swipe"
              element={
                <ProtectedRoute allowedRoles={["shopper"]}>
                  <SwipePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/matches"
              element={
                <ProtectedRoute allowedRoles={["shopper", "owner"]}>
                  <MatchesPage />
                </ProtectedRoute>
              }
            />
            {/* Redirect old route to new dashboard */}
            <Route path="/my-properties" element={<Navigate to="/owner-dashboard" replace />} />
            <Route
              path="/owner-dashboard"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <OwnerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <PaymentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment-success"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <PaymentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent-dashboard"
              element={
                <ProtectedRoute allowedRoles={["agent"]}>
                  <AgentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-dashboard"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
